import { render, staticRenderFns } from "./c_select_item.vue?vue&type=template&id=1ecf35b9&scoped=true"
import script from "./c_select_item.vue?vue&type=script&lang=js"
export * from "./c_select_item.vue?vue&type=script&lang=js"
import style0 from "./c_select_item.vue?vue&type=style&index=0&id=1ecf35b9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecf35b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecf35b9')) {
      api.createRecord('1ecf35b9', component.options)
    } else {
      api.reload('1ecf35b9', component.options)
    }
    module.hot.accept("./c_select_item.vue?vue&type=template&id=1ecf35b9&scoped=true", function () {
      api.rerender('1ecf35b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_select_item.vue"
export default component.exports